import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const twoYearsOldEquipment: BlogMetaData = {
  title: 'モンテッソーリ教育のおもちゃ・知育玩具｜2歳向け教具一覧【保育士監修】',
  description:
    'モンテッソーリ教育のおもちゃ・知育玩具を2歳の発達段階別に約50点紹介。市販品・手作り別、言語・感覚・手の操作の3分野で選び方を保育士が比較表つきで解説します。',
  thumbnailUrl: '/img/blog-1-year-old-equipment.webp',
  filePath: buildBlogFilePath('2-years-old-equipment'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
